// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-7a75c850]{height:7rem;-webkit-line-clamp:4}.excerpt[data-v-7a75c850],.title[data-v-7a75c850]{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical}.excerpt[data-v-7a75c850]{height:3.25rem;-webkit-line-clamp:2}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
